import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';

import { Subject } from 'rxjs/Subject';
import { map } from 'rxjs/operators/map';
import { takeUntil } from 'rxjs/operators/takeUntil';

import { AuthService } from '../../services/authentication/auth.service';
import { SplashService } from '../../services/splash/splash.service';

@Component({
    selector: 'app-classlink-login',
    styleUrls: ['classlink.component.css'],
    templateUrl: 'classlink.component.html',
})
export class ClasslinkSSOLoginComponent implements OnDestroy, OnInit {
    private _subrelease: Subject<void> = new Subject<void>();

    constructor(private authService: AuthService, private route: ActivatedRoute, private router: Router) {}

    ngOnDestroy() {
        this._subrelease.next();
        this._subrelease.complete();
    }

    ngOnInit() {
        const self = this;

        // Listen for the parameters
        self.route.queryParamMap
            .pipe(
                takeUntil(self._subrelease),
                map(params => {
                    return {
                        Token: params.get('code'),
                    };
                })
            )
            .subscribe(ssoinfo => {
                // If we're landing here, and there's no token provided, this must be the initial landing on the page from Classlink.
                // We must redirect back to them via the client_id value so ClassLink can prompt for authentication,
                // and then it'll return back here with the token, from which we can continue authentication.
                if (!ssoinfo || !ssoinfo.Token) {
                    // Initial Classlink redirect
                    if (window.location.href.indexOf('localhost') >= 0) {
                        window.location.href =
                            `https://launchpad.classlink.com/oauth2/v2/auth?scope=full&redirect_uri=` +
                            `http%3A%2F%2Flocalhost%3A4213%2Fclasslink&client_id=` +
                            `c1533930982390b811e1c30fac9bd5a5a0972ec114c3a5&response_type=code`;
                    } else if (window.location.host.toLowerCase().indexOf('apptest.polk') >= 0) {
                        window.location.href =
                            `https://launchpad.classlink.com/oauth2/v2/auth?scope=full&redirect_uri=` +
                            `https%3A%2F%2Fapptest.polk-fl.net%2Fclasslink&client_id=` +
                            `c1541081985274ccc5cdd6ebd7758f393dcc9ac278f657&response_type=code`;
                    } else if (window.location.href.indexOf('deltadev') >= 0) {
                        window.location.href =
                            `https://launchpad.classlink.com/oauth2/v2/auth?scope=full&redirect_uri=` +
                            `https%3A%2F%2Fdeltadev.polk-fl.net%2Fclasslink&client_id=` +
                            `c15341664388746e944194595bd0f182c950954c850d84&response_type=code`;
                    } else {
                        window.location.href =
                            `https://launchpad.classlink.com/oauth2/v2/auth?scope=full&redirect_uri=` +
                            `https%3A%2F%2Fdelta.polk-fl.net%2Fclasslink&client_id=` +
                            `c1533930409712e0982b01cecbb456d585c1084d8f4ab4&response_type=code`;
                    }

                    return;
                }

                // This is a redirect from Classlink back to us. In this case, extract the token and process it for logging in.
                const decodedToken = decodeURIComponent(ssoinfo.Token);

                // Grab the screen and window resolutions
                const scr = window.screen.width + 'x' + window.screen.height;
                const win = window.innerWidth + 'x' + window.innerHeight;

                // Pass to the Classlink SSO Login routine
                self.authService.ClasslinkSSOLogin(decodedToken, scr, win).subscribe(
                    UserInfo => {
                        // Use the returned user info to complete the "login" process.
                        self.authService.ProcessLogin(UserInfo);
                        return;
                    },
                    error => {
                        self.authService.HandleServiceError(error);

                        // Transition to the regular login route
                        self.router.navigate(['/login']);
                    }
                );
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/classlink/classlink.component.ts